import { addParameterToUrl as e, getParameterFromUrl as t, removeParamsFromUrl as n } from "../utils/url.js";
import { c as r } from "react/compiler-runtime";
import { useState as i } from "react";
//#region src/hooks/usePagination.ts
var a = 1, o = 24, s = "page", c = "pageSize";
function l(n, l) {
	let f = r(14), p = l === void 0 ? o : l, m;
	f[0] === Symbol.for("react.memo_cache_sentinel") ? (m = t(s, !0, !1) || a, f[0] = m) : m = f[0];
	let [h, g] = i(m), _;
	f[1] === p ? _ = f[2] : (_ = t(c, !0, !1) || p, f[1] = p, f[2] = _);
	let [v, y] = i(_), b;
	bb0: {
		if (n !== void 0) {
			b = Math.max(1, Math.ceil(n / v));
			break bb0;
		}
		b = void 0;
	}
	let x = b, S;
	bb1: {
		if (x === void 0 || h <= x) {
			S = h;
			break bb1;
		}
		S = x;
	}
	let C = S, [w, T] = i(C);
	C !== w && (T(C), C !== h && (g(C), e(s, C.toString(), !1)));
	let E = Math.max(0, (C - 1) * v), D;
	f[3] === Symbol.for("react.memo_cache_sentinel") ? (D = (t) => {
		g(t), e(s, t.toString(), !1);
	}, f[3] = D) : D = f[3];
	let O = D, k;
	f[4] === Symbol.for("react.memo_cache_sentinel") ? (k = (t) => {
		y(t), e(c, t.toString(), !1);
	}, f[4] = k) : k = f[4];
	let A = k, j = u, M;
	f[5] === Symbol.for("react.memo_cache_sentinel") ? (M = () => {
		O(a);
	}, f[5] = M) : M = f[5];
	let N = M, P;
	f[6] !== E || f[7] !== v ? (P = (e) => d(e, v, E), f[6] = E, f[7] = v, f[8] = P) : P = f[8];
	let F = P, I;
	return f[9] !== C || f[10] !== E || f[11] !== v || f[12] !== F ? (I = {
		offset: E,
		currentPage: C,
		pageSize: v,
		onPageChange: O,
		onPageSizeChange: A,
		queryWithPagination: F,
		resetPage: N,
		removePageFromUrl: j
	}, f[9] = C, f[10] = E, f[11] = v, f[12] = F, f[13] = I) : I = f[13], I;
}
function u() {
	n([s]);
}
var d = (e, t, n = 0) => ({
	...e,
	offset: n,
	limit: t ?? o
});
//#endregion
export { d as addPaginationParams, l as usePagination };
